import './ProductsList.css';
import './AddCoupon.css';
import './AddDiscount.css';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCheck, faHeart, faTrash } from '@fortawesome/free-solid-svg-icons';
import { useState, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { product, add_discount, searsh_product , all_discount, remove_discount_product} from "./Redux/API";
import Loader from './Loader';
import Header from './Header/Header';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';

function AddDiscountAdmin() {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const vendor_product = useSelector(state => state.Data.vendor_products);
  const loadingVendor_products = useSelector(state => state.Data.loadingVendor_products);
  
  const [selectedProducts, setSelectedProducts] = useState([]);
  const [selectedCouponId, setSelectedCouponId] = useState(""); // Store coupon ID
  const [errorMessage, setErrorMessage] = useState(""); // Error message state

  const loadingAll_coupon = useSelector(state => state.Data.loadingAll_coupon);
  const loadingAdd_discount = useSelector(state => state.Data.loadingAdd_discount);
  const all_discounts = useSelector(state => state.Data.all_discount);
  const add_discounts = useSelector(state => state.Data.add_discount);

  const loadingSearsh_product = useSelector(state => state.Data.loadingSearsh_product);
  const loadingRemove_discount_product = useSelector(state => state.Data.loadingRemove_discount_product);

  const products = useSelector(state => state.Data.product);
  const searsh_products = useSelector(state => state.Data.searsh_product);
  const [showPopup, setShowPopup] = useState(false);

    // **حالة البحث**
    const [searshBroduct, setSearshBroduct] = useState('');
    const handleInputChangeReturns = (e) => {
      setSearshBroduct(e.target.value); 
    };
  
    useEffect(() => {
        dispatch(searsh_product(searshBroduct)); // استدعاء البحث
    }, [searshBroduct, dispatch]);
  
  
    useEffect(() => {
      dispatch(all_discount());
      dispatch(product()); 
    }, [dispatch, loadingAdd_discount, loadingRemove_discount_product]);


  const handleSelectProduct = (e, productId) => {
    if (e.target.checked) {
      setSelectedProducts([...selectedProducts, productId]);
    } else {
      setSelectedProducts(selectedProducts.filter(id => id !== productId));
    }
  };

  

  const handleCouponChange = (e) => {
    setSelectedCouponId(e.target.value);
  };

  const [success, setSuccess] = useState(false);
  const handleSubmit = () => {
    if (!selectedCouponId && selectedProducts.length === 0) {
      setErrorMessage(t('errors.select_coupon_and_products')); 
      setShowPopup(true);
      setTimeout(() => setShowPopup(false), 3000);
    } else if (!selectedCouponId) {
      setErrorMessage(t('errors.select_coupon')); 
      setShowPopup(true);
      setTimeout(() => setShowPopup(false), 3000);
    } else if (selectedProducts.length === 0) {
      setErrorMessage(t('errors.select_products'));
      setShowPopup(true);
      setTimeout(() => setShowPopup(false), 3000);
    } else {
      setErrorMessage(""); 
      dispatch(add_discount({
        product_ids: selectedProducts,
        discount_id: selectedCouponId // Send the coupon ID
      })).then((action) => {
        if (action.payload && action.payload.success) {
            setSuccess(true); // تحديث الحالة عند نجاح العملية
        }
      });
    }
  };

  const handleDelete = () => {
    if (!selectedCouponId && selectedProducts.length === 0) {
      setErrorMessage(t('selectProducts')); 
      setShowPopup(true);
      setTimeout(() => setShowPopup(false), 3000);
    } else {
      setErrorMessage(""); 
      dispatch(remove_discount_product({
        product_ids: selectedProducts,
      }));
    }
  };


  const listOrders = [t('products_list.product_name'), t('products_list.category'), t('products_list.price'), t('products_list.coupon'), t('products_list.discount')];


  return (
    <div className="ProductsList">
      <Header />
      <div className='container-fluid'>
        <div className='row align-items-center'>
          <div className='name_header d-flex'>
            <i className='font-size3'><FontAwesomeIcon icon={faHeart} /></i>
            <p>{t('favorites')}</p>
          </div>
        </div>

        <div className='container mt-3'>
          <div className='row'>
            <div className={`popup ${showPopup ? 'show' : ''}`}>{errorMessage}</div>

            <div className='sarsh justify-content-between d-flex mt-3 mb-3'>

              <div className='sarsh col-5'>
                <input type="text" value={searshBroduct} onChange={handleInputChangeReturns} placeholder={t('products_list.search')} />
              </div>

              <div>
                <div className="form-group w-100">
                <select 
                  id="couponSelect"
                  className="form-select select-coupons w-100"
                  value={selectedCouponId} 
                  onChange={handleCouponChange}
                >
            <option value="">{t('select_discount')}</option>
            {all_discounts?.data?.data?.discounts.map(coupon => (
                    <option key={coupon.id} value={coupon.id} className="coupon-option">
                      <span className="coupon-name">{`name: ${coupon.name}`}</span>
                      &nbsp;&nbsp;&nbsp;&nbsp; 
                      <span className="coupon-discount">{`Discount: ${coupon.discount_value}`}</span>
                    </option>           
                  ))}
                </select>
              </div>
              </div>
            </div>
          </div>
        </div>
        <div className='row d-flex justify-content-between'>
        <button onClick={handleDelete}>{t('remove_discount')}</button>
        <button onClick={handleSubmit}>{t('actions.apply_discount')}</button>
        </div>

        <div className='container'>
          {loadingVendor_products && <Loader />}
          {loadingAdd_discount && <Loader />}
          {loadingSearsh_product && <Loader />}
          {loadingRemove_discount_product && <Loader />}
          <div className='Orders'>
            <div className='Orders_border row justify-content-between'>
              {listOrders.map((e, index) => (
                <p className='col-2 text-center mb-3' key={index}>{e}</p>
              ))}
            </div>





            {searshBroduct
            ? (  
                searsh_products?.data?.data.map((item) => (
                    <div key={item.id}>
                    <div className='Orders_border hover row align-items-center justify-content-between'>
                      <input className='checkbox_discount'
                        type="checkbox" 
                        onChange={(e) => handleSelectProduct(e, item.id)} 
                      />
                      <p className='col-2 text-center'><span>{item.name}</span></p>
                      <p className='col-2 text-center'>{item.category}</p>
                      <p className='col-2 text-center'>{item.new_price}</p>
                      <p className='col-2 text-center'>{item?.coupons[0]?.code}</p>
                      <p className='col-2 text-center'>{item.discount}</p>
                    </div>
                  </div>
                  ))
            )
            :
            (

                products?.data?.data.map((item) => (
                    <div key={item.id}>
                    <div className='Orders_border hover row align-items-center justify-content-between'>
                      <input className='checkbox_discount'
                        type="checkbox" 
                        onChange={(e) => handleSelectProduct(e, item.id)} 
                      />
                      <p className='col-2 text-center'><span>{item.name}</span></p>
                      <p className='col-2 text-center'>{item.category}</p>
                      <p className='col-2 text-center'>{item.new_price}</p>
                      <p className='col-2 text-center'>{item?.coupons[0]?.code}</p>
                      <p className='col-2 text-center'>{item.discount}</p>
                    </div>
                  </div>
                  ))
                )}

          </div>
        </div>
      </div>
      {success && (
          <div className="popup-message">
              <div className="popup-conten">
              {add_discounts?.data?.message&&
              <FontAwesomeIcon icon={faCheck} className='mx-1' />
              }
              <span>{add_discounts?.data?.message}</span>
              </div>
          </div>
      )}
    </div>
  );
}

export default AddDiscountAdmin;